{
  "createUser": {
    "title": "Create new user"
  },
  "editUser": {
    "title": "Edit user"
  },
  "selectUserProfileEdit": {
    "title": "Select user's profile"
  },
  "userGroups": {
    "title": "Select user's groups"
  }
}
